export type TShiftSchedule = {
  shift: string;
  shift_id: number;
  date: string;
  time_start: Date;
  time_end: Date;
  spots_left: number;
  signup_count: number;
  max_volunteer_count: number;
  role: string;
  registration_open: boolean;
};

export type TIsRegistered = {
  registered: boolean;
  shouldShow: boolean;
  shift_id: number;
};

export enum DISABLE_REASONS {
  REGISTRATION_CLOSED,
  NO_SPOTS_LEFT,
  TIME_CONFLICT,
  MIN_SIGN_UPS,
  NOT_MATCHING_PRIMARY_ROLE,
}

export type TIsDisabled = {
  disabled: boolean;
  reason: string;
  /** typed lock cause for icons; optional while older call sites only set reason */
  kind?: DISABLE_REASONS;
};
